import type { ReactNode } from 'react';
import { useHasPermission } from './PermissionsProvider';

interface AccessProps {
  requiredPermit: Permit;
  denied?: ReactNode;
  children: ReactNode;
}

/**
 * Validates that user has global permission to access component. If granted the
 * child component is displayed, otherwise not.
 *
 * @param requiredPermit Permit to check access for
 * @param denied
 * @param children Component to render, if the user has permit
 * @constructor
 */
const Access = ({ requiredPermit, denied, children }: AccessProps) => {
  const hasGlobalPermit = useHasPermission(requiredPermit);

  if (!hasGlobalPermit) {
    return <>{denied ?? null}</>;
  }

  return <>{children}</>;
};

export default Access;
